export const existenceFloatingAndBundles = params => {
  if (params.data) {
    let generatedStr = ``;
    if (params.data.floating_length) {
      generatedStr += ' f';
    }
    if (params.data.bundles) {
      generatedStr += ' b';
    }
    return `<div style="font-weight: bold; margin-left: 5px;">${generatedStr}</div>`;
  }
};


// WEBPACK FOOTER //
// ./src/helpers/order-products-helpers.js